import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactElement;
  requireAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requireAdmin }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  let isAdmin = false;
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      isAdmin = payload?.isadmin?.toString() === 'true';
    } catch (err) {
      console.error('Invalid token or decoding error', err);
    }
  }

  if (!token) return <Navigate to="/login" />;
  if (requireAdmin && !isAdmin) return <Navigate to="/forbidden" />;

  const currentPath = location.pathname;

  // Admin: Redirect if /portal/home is restricted
  if (isAdmin && currentPath === '/portal/home') {
    const hasHome = checkAccess('a1b2c3d4-e5f6-7890-abcd-ef1234567890');
    if (!hasHome) {
      return <Navigate to={getAllowedPortalPath()} replace />;
    }
  }

  // Non-admin: Redirect from /chat if not allowed
  if (!isAdmin && currentPath === '/chat') {
    const chatAllowed = checkAccess('q3r4s5t6-u7v8-9012-7890-123456789012');
    if (!chatAllowed) {
      return <Navigate to={getAllowedPortalPath()} replace />;
    }
  }

  return children;
};

function checkAccess(id: string): boolean {
  try {
    const routes = JSON.parse(localStorage.getItem('user_routes') || '[]');

    const findRecursive = (items: any[]): boolean =>
      items.some((r) =>
        r.id === id
          ? r.hasAccess
          : Array.isArray(r.children) && findRecursive(r.children)
      );

    return findRecursive(routes);
  } catch {
    return false;
  }
}

function getAllowedPortalPath(): string {
  try {
    const routes = JSON.parse(localStorage.getItem('user_routes') || '[]');

    const flatten = (items: any[]): string[] =>
      items.flatMap((r) =>
        r.hasAccess
          ? [r.path ?? '', ...(Array.isArray(r.children) ? flatten(r.children) : [])]
          : []
      );

    const paths = flatten(routes)
      .filter((p) => !!p)
      .map((p) =>
        p.startsWith('/portal') || p.startsWith('/chat') ? p : `/portal/${p.replace(/^\/+/, '')}`
      );

    return (
      paths.find((p) => p !== '/portal/home' && p !== '/chat') || '/portal/my-account'
    );
  } catch {
    return '/portal/my-account';
  }
}

export default PrivateRoute;


// import React from 'react';
// import { Navigate } from 'react-router-dom';

// interface PrivateRouteProps {
//   children: React.ReactElement;
//   requireAdmin?: boolean;
// }

// const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requireAdmin   }) => {
//   const token = localStorage.getItem('token');

//   let isAdmin = false;

//   if (token) {
//     try {
//       const payload = JSON.parse(atob(token.split('.')[1]));
//       isAdmin = payload?.isadmin.toString()=='true' ;
//     } catch (err) {
//       console.error('Invalid token or decoding error', err);
//     }
//   }

//   if (!token) {
//     return <Navigate to="/login" />;
//   }

//   if (requireAdmin && !isAdmin) {
//     return <Navigate to="/forbidden" />;
//   }

//   return children;
// };

// export default PrivateRoute;
